<template>
  <el-form-item
    :label="label"
    :prop="name"
    :rules="rules"
    >
    <el-row :gutter="20" v-for="item in map" :key="item.id">
      <el-col :xs="24" :md="6">
        <el-switch class="switch-padding-top"
          @change="onInput()"
          v-model="item.enable"
          :active-text="item.label"
        >
        </el-switch>
      </el-col>
      <el-col :xs="24" :md="columnWidth">
        <text-field
          v-if="hasX"
          @input="onInput()"
          v-model.number="item.val_x"
          name="val_x"
          :base="base"
          :disabled="!item.enable"
        >
        </text-field>
      </el-col>
      <el-col :xs="24" :md="columnWidth">
        <text-field
          v-if="hasY"
          @input="onInput()"
          v-model.number="item.val_y"
          name="val_y"
          :base="base"
          :disabled="!item.enable"
        >
        </text-field>
      </el-col>
      <el-col :xs="24" :md="columnWidth">
        <text-field
          v-if="hasZ"
          @input="onInput()"
          v-model.number="item.val_z"
          name="val_z"
          :base="base"
          :disabled="!item.enable"
        >
        </text-field>
      </el-col>
    </el-row>
  </el-form-item>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'promo-amount',
  props: {
    value: {
      type: Array,
      required: true
    },
    base: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    hasX: {
      type: Boolean,
      default: true
    },
    hasY: {
      type: Boolean,
      default: true
    },
    hasZ: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    val () {
      var amounts = []
      for (var key in this.map) {
        if (this.map[key].enable) {
          amounts.push(_.pick(this.map[key], [
            'currency_id',
            'val_x',
            'val_y',
            'val_z'
          ]))
        }
      }

      return amounts
    },
    columnWidth () {
      const count = [this.hasX, this.hasY, this.hasZ].filter(Boolean).length
      return count === 3 ? 6 : count === 2 ? 9 : 18
    }
  },
  data () {
    return {
      rules: [{
        required: true,
        validator: this.validAmountsArray,
        trigger: 'blur'
      }],
      map: {}
    }
  },
  mounted () {
    this.setMap()
    this.$ebus.$on('renewLang', this.resetMap)
  },
  beforeDestroy () {
    this.$ebus.$off('renewLang', this.resetMap)
  },
  methods: {
    resetMap () {
      this.$store.dispatch('ResetCurrency')
      this.setMap()
    },
    setMap () {
      this.$store.dispatch('InitCurrency')
        .then((data) => {
          if (data && data.opts) {
            let m = Object.assign({}, this.map)
            this.map = {}
            data.opts.forEach((c) => {
              this.$set(this.map, c.id, {
                currency_id: c.id,
                enable: m[c.id] ? m[c.id].enable : false,
                label: c.name,
                val_x: m[c.id] ? m[c.id].val_x : 0,
                val_y: m[c.id] ? m[c.id].val_y : 0,
                val_z: m[c.id] ? m[c.id].val_z : 0
              })
            })
          }
        })
    },
    onInput () {
      this.$emit('input', this.val)
    },
    validAmountsArray (rule, value, callback) {
      if (value === undefined || value.length <= 0) {
        callback(new Error(this.$t('api.promo.error.at_least_one_amount')))
        return
      }

      callback()
    }
  },
  watch: {
    value: {
      handler (newValue) {
        newValue.forEach((item) => {
          if (this.map[item.currency_id]) {
            this.map[item.currency_id].enable = true
            this.map[item.currency_id].val_x = item.val_x
            this.map[item.currency_id].val_y = item.val_y
            this.map[item.currency_id].val_z = item.val_z
          }
        })
      },
      immediate: true
    }
  }
}
</script>
<style scoped>
  @media only screen and (min-width: 992px) {
    .switch-padding-top {
      padding-top: 52px
    }
  }
</style>
